export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/72a061e4da900bb3a21b7904c48e0b41.svg";